export default __webpack_public_path__ + "static/media/connectchore.ca552126.png";